<!-- UserPage.vue: 管理ページでユーザー個々の情報を表示するページ -->
<template lang="html">
  <div class="userPage">
    <router-link tag="button" :to="{ name: 'ManagementPage' }">戻る</router-link>
    <h1>講義情報</h1>
    <table id="userPartnerList">
      <caption>ユーザー：{{ getWho.fullname }}</caption>
      <thead>
        <tr>
          <th>
            <template v-if="getWho.type === 'teacher'">
              <div>生徒一覧</div>
            </template>
            <template v-if="getWho.type === 'student'">
              <div>先生一覧</div>
            </template>
          </th>
          <th style="width: 10%">削除</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(partner, index) in partnerList" :key="partner.id"
        :class="{ evenRow: index % 2 === 0 }">
          <th>
            {{ partner.fullname }}
          </th>
          <th><button @click="purgeLecture(partner)">x</button></th>
        </tr>
      </tbody>
    </table>
    <div id="EditLecturePanel">
      <table border="1">
        <caption>
          講義情報を追加する
        </caption>
        <thead>
          <th style="width: 40%;">教師名</th>
          <th style="width: 40%;">生徒名</th>
          <th style="width: auto;"></th>
        </thead>
        <tbody>
          <tr>
            <td v-if="getWho.type === 'teacher'">
                <input type="text" :value="getWho.fullname" disabled/>
                <input type="hidden" :value="setHiddenID('teacher')"/>
            </td>
            <td v-else>
              <select v-model="lecture.teacher" style="width: 100%;">
                <option v-for="(teacher, index) in sortedTeacherList"
                :key="teacher.user_id"
                :value="teacher.user_id">{{teacher.fullname}}</option><!-- v-for="user in AvailUsers" -->
              </select>
            </td>
            <td v-if="getWho.type === 'student'">
                <input type="text" :value="getWho.fullname" disabled/>
                <input type="hidden" :value="setHiddenID('student')"/>
            </td>
            <td v-else>
              <select v-model="lecture.student" style="width: 100%;">
                <option v-for="(student, index) in sortedStudentList"
                :key="student.user_id"
                :value="student.user_id">{{student.fullname}}</option>
              </select>
            </td>
            <td><button @click="registerLecture()">登録</button></td>
          </tr>
        </tbody>
      </table>
    </div>
    <router-link :to="{ name: 'EditLecturePage' }"></router-link>
    <div v-if="getWho.type === 'teacher'">
      <table border="1">
        <tr>
          <td>
            日曜日の講義
          </td>
          <td>
            {{ isSunday ? '有り' : '無し' }}
          </td>
          <td>
            <button v-if="!isSunday" type="button" @click="registerSunday">登録</button>
            <button v-else type="button" @click="deleteSunday">削除</button>
          </td>
        </tr>
      </table>
    </div>
    <password-change-panel :user_id="getWho.id"></password-change-panel>
    <user-name-change-panel :user_id="getWho.id" :current_user_name="getWho.user_name" @changed="userInfoChanged()"></user-name-change-panel>
    <fullname-change-panel :user_id="getWho.id" :current_fullname="getWho.fullname" :current_kana="getWho.kana" @changed="userInfoChanged()" ></fullname-change-panel>
    <mail-address-change-panel :user_id="getWho.id" :current_mail="getWho.mail_address"></mail-address-change-panel>
    <status-change-panel :user_id="getWho.id" :current_status="getWho.status"></status-change-panel>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'
import PCPanel from '../UserInfo/PasswordChangePanel'
import UCPanel from '../UserInfo/UserNameChangePanel'
import FCPanel from '../UserInfo/FullnameChangePanel'
import MCPanel from '../UserInfo/MailAddressChangePanel'
import SCPanel from '../UserInfo/StatusChangePanel'
import sundayApi from '@/api/sunday_teachers'
import lecturesApi from '@/api/lectures'
export default {
  components: {
    'password-change-panel': PCPanel,
    'user-name-change-panel': UCPanel,
    'fullname-change-panel': FCPanel,
    'mail-address-change-panel': MCPanel,
    'status-change-panel': SCPanel
  },
  data () {
    return {
      lecture: {
        teacher: 0,
        student: 0
      },
      isSunday: false
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'getUserLectures',
      'addLecture',
      'updateUserList'
    ]),
    getListItem (ulect) {
      let type = this.getWho.type
      switch (type) {
        case 'teacher':
          return ulect.student.fullname
        case 'student':
          return ulect.teacher.fullname
        default:
          return ''
      }
    },
    purgeLecture (partner) {
      let isYes = confirm('講義を削除します．よろしいですか？' + partner.id)
      console.log(partner)
      if (isYes) {
        lecturesApi.getByUserId(this.getWho.id)
          .then((res) => {
            console.log(res.data.lectures)
            let lectid = res.data.lectures.find((item) => item.student.id === partner.id).id
            this.$store.dispatch('deleteLecture', lectid)
          })
        .then((res) => {
          alert('講義の削除に成功しました．')
          this.$store.dispatch('updateUserList').then(() => {
            this.$store.dispatch('getUserLectures', this.getWho.id)
          })
        })
      }
    },
    registerLecture () {
      this.addLecture({
        teacher: parseInt(this.lecture.teacher),
        student: parseInt(this.lecture.student)
      })
      .then(() => {
        this.getUserLectures(this.getWho.id)
      })
    },
    setHiddenID (type) {
      switch (type) {
        case 'teacher':
          this.lecture.teacher = parseInt(this.getWho.id)
          return this.teacher
        case 'student':
          this.lecture.student = parseInt(this.getWho.id)
          return this.student
        default:
          break
      }
    },
    registerSunday () {
      if (this.getWho.type === 'teacher') {
        sundayApi.post(this.getWho.id)
        .then((res) => {
          alert('登録に成功しました')
          this.$store.dispatch('updateUserList').then(() => {
            this.$store.dispatch('getUserLectures', this.getWho.id)
          })
        }).catch((err) => {
          alert('登録に失敗しました: ' + err.response.data.message)
        })
      }
    },
    deleteSunday () {
      if (this.getWho.type === 'teacher') {
        sundayApi.delete(this.getWho.id)
        .then((res) => {
          alert('削除に成功しました')
          this.$store.dispatch('updateUserList').then(() => {
            this.$store.dispatch('getUserLectures', this.getWho.id)
          })
        }).catch((err) => {
          alert('削除に失敗しました: ' + err.response.data.message)
        })
      }
    },
    userInfoChanged () {
      this.$store.dispatch('updateUserList')
      this.$store.dispatch('getUserLectures', this.getWho.id)
    },
    sortByKana (userList) {
      return userList.sort((a, b) => {
        return (a.kana > b.kana) ? 1 : (a.kana < b.kana ? -1 : 0)
      })
    }
  },
  computed: {
    ...mapGetters([
      'teacherList',
      'studentList'
    ]),
    sortedTeacherList () {
      return this.sortByKana(this.teacherList.filter((user, index, array) => {
        return this.$store.state.userInfo
      }))
    },
    sortedStudentList () {
      return this.sortByKana(this.studentList.filter((user, index, array) => {
        return user.school_id === parseInt(this.$store.state.userInfo.school_id)
      }))
    },
    partnerList () {
      return this.sortByKana(
        this.$store.state.userLectures
        .map((lect) => {
          return (this.getWho.type === 'teacher') ? lect.student : lect.teacher
        }))
    },
    getWho () {
      let id = parseInt(this.$route.params.id)
      /*
        userLecturesからユーザ情報を探すと，何故か，user_nameがgetWho.user_nameで取得できないので，userListから直接探すのみにする
        理由が不明なので，前のコードもとりあえずコメントアウトで残しておく(2017-12-09)
      */
      // if (this.$store.state.userLectures.length === 0) {
      let theuser = this.$store.state.userlist.find((user, index, array) => {
        return user.user_id === id
      })
      if (theuser) {
        return {
          fullname: theuser.fullname,
          kana: theuser.kana,
          id: theuser.user_id,
          type: theuser.user_type,
          user_name: theuser.user_name,
          mail_address: theuser.mail_address,
          status: theuser.status
        }
      }
      // }
      /*
      for (let ulect of this.$store.state.userLectures) {
        if (ulect.student.id === id) {
          return {
            fullname: ulect.student.fullname,
            id: ulect.student.id,
            type: 'student',
            user_name: ulect.student.user_name
          }
        } else if (ulect.teacher.id === id) {
          return {
            fullname: ulect.teacher.fullname,
            id: ulect.teacher.id,
            type: 'teacher',
            user_name: ulect.teacher.user_name
          }
        }
      }
      */
      return 'Unknown'
    }
  },
  created () {
    Promise.resolve()
    .then(() => {
      // ユーザリストが空の場合は更新する
      if (this.$store.state.userlist.length === 0) {
        return this.updateUserList()
      } else {
        return Promise.resolve()
      }
    })
    .then(() => {
      if (this.getWho.type === 'teacher') {
        let index = this.$store.state.userlist.findIndex((elem, index, self) => {
          return elem.user_id === this.getWho.id
        })
        this.isSunday = this.$store.state.userlist[index].is_Sunday_user
      }
      this.getUserLectures(this.getWho.id)
    })
  }
}
</script>

<style lang="css" scoped>
table {
  width: 50%;
  margin: auto;
}
.evenRow {
  background-color: #ffffaa
}
#userPartnerList {
  border-style: solid;
}
#userPartnerList tbody>tr:hover {
  background-color: #ffcccc
}
.userPage {
  margin-bottom: 5%;
}
</style>



// WEBPACK FOOTER //
// UserPage.vue?20a5db32